import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
type GenerateMeetingAgendaInput = {
  templateId: string;
  // Clients to build the agenda for. Chosen in the modal and sent explicitly so the
  // agenda's attendees are independent of the meeting's participants. Omitted (e.g. the
  // auto-generate deep link) means the backend falls back to the meeting's clients.
  clientIds?: string[];
};

export const useGenerateCalendarEventMeetingAgenda = (eventId: string) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    isError,
    isSuccess,
  } = useMutation<unknown, Error, GenerateMeetingAgendaInput>({
    mutationFn: (input: GenerateMeetingAgendaInput) =>
      api.post(`calendar-events/${eventId}/meeting-agenda`, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events', eventId, 'meeting-agenda'] });
    },
  });

  const generateMeetingAgenda = async (input: GenerateMeetingAgendaInput) => {
    await mutateAsync(input);
  };

  return {
    generateMeetingAgenda,
    isLoading,
    error,
    isError,
    isSuccess,
  };
};
